import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, children, closeOnOverlayClick = true, size = 'md' }) => {
  const mouseDownRef = useRef(null);
  const isDraggingRef = useRef(false);

  if (!isOpen) return null;

  const handleMouseDown = (e) => {
    // Solo registrar si el clic es directamente en el overlay
    if (e.target === e.currentTarget && closeOnOverlayClick) {
      mouseDownRef.current = {
        x: e.clientX,
        y: e.clientY,
        target: e.target
      };
      isDraggingRef.current = false;
    }
  };

  const handleMouseMove = (e) => {
    // Si el mouse se mueve después de un mousedown, es un arrastre
    if (mouseDownRef.current) {
      const distance = Math.sqrt(
        Math.pow(e.clientX - mouseDownRef.current.x, 2) +
        Math.pow(e.clientY - mouseDownRef.current.y, 2)
      );
      // Si se movió más de 5 píxeles, es un arrastre
      if (distance > 5) {
        isDraggingRef.current = true;
      }
    }
  };

  const handleMouseUp = (e) => {
    // Solo cerrar si:
    // 1. El clic fue directamente en el overlay
    // 2. No fue un arrastre (drag)
    // 3. closeOnOverlayClick está habilitado
    if (
      mouseDownRef.current &&
      e.target === e.currentTarget &&
      !isDraggingRef.current &&
      closeOnOverlayClick
    ) {
      onClose();
    }
    // Resetear referencias
    mouseDownRef.current = null;
    isDraggingRef.current = false;
  };

  return ReactDOM.createPortal(
    <div 
      className="modal-overlay" 
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={() => {
        // Resetear si el mouse sale del overlay
        mouseDownRef.current = null;
        isDraggingRef.current = false;
      }}
    >
      <div className={`modal-content${size !== 'md' ? ` modal-content--${size}` : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;

